import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import './LivingLabsPage.css'

function LivingLabsPage() {
    return (
        <div className="LivingLabsPage">
            <Navbar />
            <div className="living-labs-page">
                <section className="ll-hero">
                    <div className="ll-hero-cities">
                        <span>NYC.</span>
                        <span>SEATTLE.</span>
                        <span>EL PASO.</span>
                    </div>
                    <h1 className="ll-hero-title">A Network of Living Labs</h1>
                    <h3 className="ll-hero-subtitle">Digital Twin solutions for Mobility and Safety</h3>
                    <p className="ll-hero-desc">
                        C2SMART leverages Digital Twin technology to facilitate interactions between individuals,
                        the built environment, and their interconnected networks. Utilizing a comprehensive approach
                        that includes statistical methods and artificial intelligence techniques, C2SMART seeks to
                        unravel complex urban phenomena across microscopic, mesoscopic, and macroscopic levels of
                        transportation dynamics. This strategic application of Digital Twin technology empowers
                        C2SMART to offer innovative solutions that address the multifaceted challenges faced by
                        modern urban systems.
                    </p>
                </section>

                <section className="ll-section">
                    <h3 className="ll-section-subtitle">
                        Virtual testbeds to model and test new transportation technologies and policies
                    </h3>
                    <p className="ll-section-text">
                        Transportation professionals are being challenged more than ever before to understand the
                        impacts of new technologies and sweeping policy changes, a process which often involves
                        high costs and risks to operations and safety. Moreover, emerging transportation alternatives
                        and technologies, such as connected and autonomous vehicles and Mobility-as-a-Service,
                        cannot be readily modeled using existing commercial tools. C2SMART seeks to alleviate these
                        issues by building virtual testbeds, to allow for simulation-based deployment testing within
                        a consistent virtual ecosystem that covers all transportation users.
                    </p>
                </section>

                <section className="ll-lab">
                    <h4 className="ll-lab-label">A MULTI-AGENT, SIMULATION-BASED VIRTUAL TESTBED ECOSYSTEM</h4>
                    <h2 className="ll-lab-title">MATSim-NYC</h2>
                    <div className="ll-lab-content">
                        <div className="ll-lab-image-wrap">
                            <img src="/living-labs-images/matsim-nyc.png" alt="MATSim-NYC visualization" className="ll-lab-image" />
                        </div>
                        <div className="ll-lab-text">
                            <p>
                                NYU researchers developed a testbed for NYC using MATSim, a Multi-Agent Transportation
                                Simulation. MATSim models transportation networks using a mesoscopic simulation based
                                on cellular automata. It is open source and many extensions have been quickly developed
                                for it to handle a wide assortment of policy needs and modes.
                            </p>
                            <p>
                                MATSim makes use of a synthetic population which is useful for modeling heterogeneous
                                population segments. It incorporates a day-to-day adjustment process that can reflect
                                learning from the population to achieve a social equilibrium under each technology scenario.
                            </p>
                            <p>
                                These research efforts created an underlying synthetic population for NYC for a recent
                                base year (2016) that includes key emerging modes like bikeshare and for-hire vehicles
                                (FHVs) and constructed, calibrated, and validated a MATSim model of NYC using the
                                synthetic population to evaluate a set of scenarios for which existing tools are not equipped.
                            </p>
                            <a href="https://c2smarter.engineering.nyu.edu/development-and-tech-transfer-of-multi-agent-virtual-simulation-testbed-ecosystem/"
                               target="_blank" rel="noopener noreferrer" className="ll-link">
                                Learn more &rarr;
                            </a>
                        </div>
                    </div>

                    <div className="ll-scenarios">
                        <h3 className="ll-scenarios-title">MATSim-NYC Scenarios</h3>
                        <div className="ll-scenarios-grid">
                            <a href="https://c2smarter.engineering.nyu.edu/using-matsim-nyc-to-optimize-the-brooklyn-bus-network-redesign/"
                               target="_blank" rel="noopener noreferrer" className="ll-scenario-card">
                                <h4>NYC Brooklyn Bus Redesign</h4>
                            </a>
                            <a href="https://c2smarter.engineering.nyu.edu/modeling-amazon-hq2/"
                               target="_blank" rel="noopener noreferrer" className="ll-scenario-card">
                                <h4>Exploring Amazon HQ</h4>
                            </a>
                            <div className="ll-scenario-card">
                                <h4>Implementation of the BQX</h4>
                            </div>
                            <div className="ll-scenario-card">
                                <h4>Optimizing Rideshare Expansion</h4>
                            </div>
                            <a href="https://c2smarter.engineering.nyu.edu/a-peek-under-the-hood-how-we-built-a-freight-model-of-new-york-city/"
                               target="_blank" rel="noopener noreferrer" className="ll-scenario-card">
                                <h4>Quantifying & Visualizing City Truck Route Network Efficiency</h4>
                            </a>
                            <div className="ll-scenario-card">
                                <h4>Post-COVID City Reopening</h4>
                            </div>
                            <div className="ll-scenario-card">
                                <h4>Determining Congestion Pricing</h4>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="ll-lab">
                    <h4 className="ll-lab-label">A Multiscale Simulation Platform for Connected and Automated Transportation Systems</h4>
                    <h2 className="ll-lab-title">MATSim-Seattle</h2>
                    <div className="ll-lab-content">
                        <div className="ll-lab-image-wrap">
                            <img src="/living-labs-images/seattle.png" alt="MATSim-Seattle visualization" className="ll-lab-image" />
                        </div>
                        <div className="ll-lab-text">
                            <p>
                                Using data provided by Washington DOT, Seattle DOT, and Bellevue DOT, UW researchers
                                are working to create a multiscale simulation of the Greater Seattle network to include
                                the Metro routes and schedules, arterial speed factors, motorway speed factors, arterial
                                capacity factors, and motorway capacity factors.
                            </p>
                            <p>
                                The simulation will allow researchers and policymakers to test vehicle/traffic control
                                algorithms, gain insights of micro/macro traffic dynamics, and design traffic management
                                strategies across Greater Seattle.
                            </p>
                            <a href="https://c2smarter.engineering.nyu.edu/a-multiscale-simulation-platform-for-connected-and-automated-transportation-systems/"
                               target="_blank" rel="noopener noreferrer" className="ll-link">
                                Learn more &rarr;
                            </a>
                        </div>
                    </div>
                </section>

                <section className="ll-lab">
                    <h4 className="ll-lab-label">Digital Twin Technologies Towards Understanding the Interactions between Transportation and other Civil Infrastructure Systems</h4>
                    <h2 className="ll-lab-title">El Paso Digital Twin</h2>
                    <div className="ll-lab-content">
                        <div className="ll-lab-image-wrap">
                            <img src="/living-labs-images/elpaso.png" alt="El Paso Digital Twin" className="ll-lab-image" />
                        </div>
                        <div className="ll-lab-text">
                            <p>
                                Digital Twin (DT) technology is a powerful decision support tool for the design,
                                maintenance, and management of transportation infrastructure, particularly for
                                studying the interdependency with other infrastructure systems.
                            </p>
                            <p>
                                UTEP researchers used the UTEP campus as a living lab by creating a DT model of
                                campus in order to study the impact of construction projects on the surrounding
                                transportation infrastructure.
                            </p>
                            <a href="https://c2smarter.engineering.nyu.edu/digital-twin-technologies-towards-understanding-the-interactions-between-transportation-and-other-civil-infrastructure-systems-2/"
                               target="_blank" rel="noopener noreferrer" className="ll-link">
                                Learn more &rarr;
                            </a>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    );
}

export default LivingLabsPage;
